export const repositoryUploadFunctions = {
    props: {
        maxUploadableFiles: {type: Number, default: null}
    },
    data: function () {
        return {
            uploadQueue: [],
            currentUpload: null,
            currentUploadProgress: 0,
        }
    },
    methods: {
        limitFiles: function(files) {
            if (this.maxUploadableFiles === null) {
                return files;
            }
            return files.slice(0, this.maxUploadableFiles);
        },
        handleUploadInputChange: function(event) {
            let shouldStartWhenParsed = this.uploadQueue.length == 0;
            this.limitFiles(Array.from(event.target.files)).forEach((file) => {
                this.uploadQueue.push(file);
            })
            if (shouldStartWhenParsed) {
                this.uploadNextFile();
            }
        },
        handleFileDrop: function(event) {
            event.preventDefault();
            let shouldStartWhenParsed = this.uploadQueue.length == 0;
            if (event.dataTransfer.files) {
                let files = this.limitFiles(event.dataTransfer.files);
                for (let i = 0; i < files.length; i++) {
                    if (event.dataTransfer.items[i].kind === 'file') {
                        this.uploadQueue.push(event.dataTransfer.items[i].getAsFile());
                    }
                }
            }
            if (shouldStartWhenParsed) {
                this.uploadNextFile();
            }
        },
        uploadNextFile: function() {
            this.currentUploadProgress = 0;
            this.currentUpload = null;
            if (this.uploadQueue.length > 0) {
                this.currentUpload = this.uploadQueue.shift()
                this.uploadFile(this.currentUpload);
            }
            this.$emit('uploadqueue', this.uploadQueue);
        },
        uploadFile: function(file, callback = null, replaceFile = null) {
            try {
                let mainComponent = this;
                let fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onloadend = (readerEvent) => {
                    let uploadData = {
                        "fileName": file.name,
                        "fileData": readerEvent.target.result,
                        "fileType": file.type,
                        "operation": "uploadFile",
                        "path": this.currentPath,
                        "repository": this.repositorySlug,
                        "replaceFile": replaceFile
                    }
                    let config = {
                        onUploadProgress: (progressEvent) => {
                            mainComponent.currentUploadProgress = progressEvent.loaded / progressEvent.total * 100;
                        }
                    }
                    window.axios.post(this.operationsUrl, uploadData, config)
                        .then((response) => {
                            if (callback) {
                                callback(response);
                            }
                            this.uploadNextFile();
                        })
                        .catch((error) => {
                            mainComponent.$emit('uploaderror', error);
                        })
                }
            } catch (error) {
                this.$emit('uploaderror', error);
            }
        },

    },
    computed: {
        currentUploadProgressPercentage: function() {
            return this.currentUploadProgress.toString()+'%';
        },
    },
    watch: {
    }
}